'use client';

import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Badge } from '@/components/ui/badge';
import { useCartStore } from '@/stores/cart-store';

interface CartButtonProps {
  onClick?: () => void;
  iconClassName?: string;
}

export default function CartButton(props: CartButtonProps) {
  const navigate = useNavigate();
  const totalItems = useCartStore(state => state.getTotalItems());

  const handleHeaderCartClick = () => {
    navigate('/cart');
  };

  return (
    <button
      onClick={props.onClick || handleHeaderCartClick}
      className="relative w-[30px] h-[30px] flex items-center justify-center"
    >
      <ShoppingCart className={`w-5 h-5 ${props.iconClassName || 'text-gray-600'}`} />
      {totalItems > 0 && (
        <Badge
          variant="default"
          className="absolute -top-1 -right-1 w-4 h-4 p-0 flex items-center justify-center text-xs bg-blue-500 hover:bg-blue-500"
        >
          {totalItems}
        </Badge>
      )}
    </button>
  );
}
